module.exports = __webpack_public_path__ + "img/icon-info-circle-grey.3fe746fa.svg";